export const currentFolderScopeLabel = "$RHJtb";
export const recursiveFolderScopeLabel = "s1_i0d";
export const allMailboxesScopeLabel = "nUbPfd";
export default {currentFolderScopeLabel,recursiveFolderScopeLabel,allMailboxesScopeLabel};